import api from './api';

const API_BASE = `/api/v1/organization`;

const organizationService = {
  // ========== District Operations ==========
  
  getDistricts: async () => {
    const response = await api.get(`${API_BASE}/districts`);
    return response.data;
  },

  getDistrict: async (districtId) => {
    const response = await api.get(`${API_BASE}/districts/${districtId}`);
    return response.data;
  },

  createDistrict: async (districtData) => {
    const response = await api.post(`${API_BASE}/districts`, districtData);
    return response.data;
  },

  updateDistrict: async (districtId, districtData) => {
    const response = await api.put(`${API_BASE}/districts/${districtId}`, districtData);
    return response.data;
  },

  deleteDistrict: async (districtId) => {
    await api.delete(`${API_BASE}/districts/${districtId}`);
  },

  // ========== Zone Operations ==========

  getZones: async (districtId = null) => {
    const params = districtId ? { district_id: districtId } : {};
    const response = await api.get(`${API_BASE}/zones`, { params });
    return response.data;
  },

  getZone: async (zoneId) => {
    const response = await api.get(`${API_BASE}/zones/${zoneId}`);
    return response.data;
  },

  createZone: async (zoneData) => {
    const response = await api.post(`${API_BASE}/zones`, zoneData);
    return response.data;
  },

  updateZone: async (zoneId, zoneData) => {
    const response = await api.put(`${API_BASE}/zones/${zoneId}`, zoneData);
    return response.data;
  },

  deleteZone: async (zoneId) => {
    await api.delete(`${API_BASE}/zones/${zoneId}`);
  },

  // ========== Group Operations ==========

  getGroups: async (zoneId = null) => {
    const params = zoneId ? { zone_id: zoneId } : {};
    const response = await api.get(`${API_BASE}/groups`, { params });
    return response.data;
  },

  getGroup: async (groupId) => {
    const response = await api.get(`${API_BASE}/groups/${groupId}`);
    return response.data;
  },

  createGroup: async (groupData) => {
    const response = await api.post(`${API_BASE}/groups`, groupData);
    return response.data;
  },

  updateGroup: async (groupId, groupData) => {
    const response = await api.put(`${API_BASE}/groups/${groupId}`, groupData);
    return response.data;
  },

  deleteGroup: async (groupId) => {
    await api.delete(`${API_BASE}/groups/${groupId}`);
  },

  // ========== Member Assignment Operations ==========

  getGroupMembers: async (groupId) => {
    const response = await api.get(`${API_BASE}/groups/${groupId}/members`);
    return response.data;
  },

  assignMemberToGroup: async (groupId, assignmentData) => {
    const response = await api.post(`${API_BASE}/groups/${groupId}/members`, assignmentData);
    return response.data;
  },

  updateMemberAssignment: async (assignmentId, assignmentData) => {
    const response = await api.put(`${API_BASE}/assignments/${assignmentId}`, assignmentData);
    return response.data;
  },

  removeMemberFromGroup: async (assignmentId) => {
    await api.delete(`${API_BASE}/assignments/${assignmentId}`);
  },

  // ========== Organization Tree ==========

  getOrganizationTree: async () => {
    const response = await api.get(`${API_BASE}/tree`);
    return response.data;
  }
};

export default organizationService;
